import { createGlobalStyle } from 'styled-components';
import backgroundImage from '../assets/background.jpg';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    background: #ffffff;
    background-image: 
      linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.9) 100%),
      url(${backgroundImage});
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    font-family: 'Rubik', 'Segoe UI', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
    color: #1f2937;
  }

  html, body, #root {
    height: 100%
  }

  #root {
    -webkit-transform: translate3d(0, 0, 0);
  }

  input {
    font-family: 'Rubik', 'Segoe UI', sans-serif;
    border-radius: 8px;
    border: 2px solid #e2e8f0;
    transition: all 0.3s ease;
    
    &:focus {
      border-color: #2563eb;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
      outline: none;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield; /* Firefox */
  }

  button {
    font-family: 'Rubik', 'Segoe UI', sans-serif;
    border-radius: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
    font-family: 'Rubik', 'Segoe UI', sans-serif;
  }

  /* ContinuumLink brand colors - Blue theme */
  :root {
    --cl-primary: #1e40af;        /* Deep blue */
    --cl-secondary: #3b82f6;      /* Medium blue */
    --cl-accent: #60a5fa;         /* Light blue */
    --cl-accent-light: #93c5fd;   /* Very light blue */
    --cl-text: #1e293b;           /* Dark slate */
    --cl-text-light: #475569;     /* Medium slate */
    --cl-background: #f8fafc;     /* Very light gray */
    --cl-surface: #ffffff;        /* White */
    --cl-border: #e2e8f0;         /* Light gray */
    --cl-hover: #2563eb;          /* Blue hover state */
  }
`;

export default GlobalStyle;
